import React from 'react';
import { Link } from 'react-router-dom';
import Header from './shared/Header';
import Navigation from './shared/Navigation';
import { getRandomColor } from '../utils/colors';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
const WritingPage = () => {
  // Use our custom hook
  useRandomLinkColors();
  return <div className="min-h-screen bg-white text-[#333333] font-serif" data-id="element-598">
      <Header data-id="element-599" />
      <main className="flex min-h-screen pt-24 px-6" data-id="element-600">
        <div className="flex flex-col md:flex-row w-full max-w-6xl mx-auto" data-id="element-601">
          <div className="w-full md:w-1/4 mb-8 md:mb-0" data-id="element-602">
            <Navigation data-id="element-603" />
          </div>
          <div className="w-full md:w-3/4 md:pl-8" data-id="element-604">
            <div className="max-w-2xl" data-id="element-605">
              <ul className="list-none leading-tight" data-id="element-606">
                <li className="mb-[0.2rem]" data-id="element-607">
                  <Link to="/giovannitti-needs-god" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-608">
                    Giovannitti Needs God (Interview, <em data-id="element-609">Badlon Magazine</em>{' '}
                    2025)
                  </Link>
                </li>
                <li className="mb-[0.2rem]" data-id="element-610">
                  <a href="https://blog.photoeye.com/2025/04/emerald-drifters-reviewed-by-madeleine.html" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-611">
                    Emerald Drifters (Review, <em data-id="element-612">Photo-Eye</em> 2025)
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
    </div>;
};
export default WritingPage;